import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/** 授权记录代码加载时的占位，保留现有筛选换行、空表和初始无分页布局 */
export function AuthorizationRecordsSkeleton() {
  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      <ListPageSkeleton
        columnCount={11}
        showPagination={false}
        contentClassName="gap-4 p-6"
        filterArea={
          <div className="flex items-end justify-between gap-4 pb-4">
            {/** 账户、平台、操作类型、状态、授权编号和日期 */}
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-4">
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[180px]" />
                <Skeleton className="h-9 w-[260px]" />
                <div className="flex items-center gap-2 pr-2">
                  <Skeleton className="h-9 w-20" />
                  <Skeleton className="h-9 w-20" />
                </div>
              </div>
            </div>
            {/** 列配置入口 */}
            <Skeleton className="h-9 w-24 shrink-0" />
          </div>
        }
      />
    </div>
  );
}
